import { MdOutlineStar, MdOutlineStarBorder } from 'react-icons/md'

import type { ReactElement } from 'react'

import './styles.scss'

const Rating = ({
  color,
  maxValue,
  size = 15,
  value,
}: {
  color?: string
  maxValue: number
  size?: number
  value: number
}): ReactElement => {
  const _value = value > maxValue ? maxValue : value

  return (
    <div className="rating-component">
      {[...new Array(_value)].map((__, idx) => (
        <MdOutlineStar color={color} data-name="filled-star" key={idx} role="icon" size={size} />
      ))}
      {[...new Array(maxValue - _value)].map((__, idx) => (
        <MdOutlineStarBorder color={color} data-name="star" key={idx} role="icon" size={size} />
      ))}
    </div>
  )
}

export default Rating
